import { BASE_URL } from "../constants/Endpoints"
import axios from "axios";
import Swal from "sweetalert2";

class ServicesRequest {
    constructor(requestUrlParam){
        this.requestUrlParam = requestUrlParam
    }
    async getProductList  (filter = null, sort = null, search = null, page = null, pageUrl = null,nPage = null) {
        
        if (pageUrl === null) {
            // Build query parameters array to avoid malformed URLs
            const queryParams = [];
            
            // Only add parameters if they have valid values
            if (search !== null && search !== undefined && search.trim() !== "") {
                queryParams.push(`search=${encodeURIComponent(search.trim())}`);
            }
            
            if (sort !== null && sort !== undefined && sort.trim() !== "") {
                queryParams.push(sort);
            }
            
            if (filter !== null && filter !== undefined && filter.trim() !== "") {
                // filter is "key=value&key2=value2" — encode each value (spaces etc.)
                const encodedFilter = filter.split("&").map((part) => {
                    const idx = part.indexOf("=");
                    if (idx === -1) return encodeURIComponent(part);
                    const key = part.slice(0, idx);
                    const val = part.slice(idx + 1);
                    return `${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
                }).join("&");
                queryParams.push(encodedFilter);
            }
            
            if (page !== null && page !== undefined && page !== "") {
                queryParams.push(`page=${page}`);
            }
            
            if (nPage !== null && nPage !== undefined && nPage !== "") {
                queryParams.push(`n_per_page=${nPage}`);
            }
            
            // Construct clean URL with proper query string
            pageUrl = `${BASE_URL}/api-v1/${this.requestUrlParam}/list`;
            if (queryParams.length > 0) {
                pageUrl += `?${queryParams.join('&')}`;
            }
        }
        
        console.log("Fetching URL:", pageUrl);

        const response = await axios({
            method: "get",
            url: pageUrl,
            withCredentials: true
        }
        ).then((response) => response.data)
            .catch((error) => {
                console.error(`API Request failed for URL: ${pageUrl}`, error);
                return error;
            });
        return response;
    
    }

    async getProductListComplete  (filter = null, sort = null, search = null, page = null, pageUrl = null,nPage = null) {
        
        if (pageUrl === null) {
            // Build query parameters array to avoid malformed URLs
            const queryParams = [];
            
            // Only add parameters if they have valid values
            if (search !== null && search !== undefined && search.trim() !== "") {
                queryParams.push(`search=${encodeURIComponent(search.trim())}`);
            }
            
            if (sort !== null && sort !== undefined && sort.trim() !== "") {
                queryParams.push(sort);
            }
            
            if (filter !== null && filter !== undefined && filter.trim() !== "") {
                // filter is "key=value&key2=value2" — encode each value (spaces etc.)
                const encodedFilter = filter.split("&").map((part) => {
                    const idx = part.indexOf("=");
                    if (idx === -1) return encodeURIComponent(part);
                    const key = part.slice(0, idx);
                    const val = part.slice(idx + 1);
                    return `${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
                }).join("&");
                queryParams.push(encodedFilter);
            }
            
            if (page !== null && page !== undefined && page !== "") {
                queryParams.push(`page=${page}`);
            }
            
            if (nPage !== null && nPage !== undefined && nPage !== "") {
                queryParams.push(`n_per_page=${nPage}`);
            }
            
            // Construct clean URL with proper query string
            pageUrl = `${BASE_URL}/api-v1/${this.requestUrlParam}/list-complete`;
            if (queryParams.length > 0) {
                pageUrl += `?${queryParams.join('&')}`;
            }
        }
        
        console.log("Fetching URL:", pageUrl);

        const response = await axios({
            method: "get",
            url: pageUrl,
            withCredentials: true
        }
        ).then((response) => response.data)
            .catch((error) => {
                console.error(`API Request failed for URL: ${pageUrl}`, error);
                return error;
            });
        return response;
    
    }

    async createProduct(formData)  {

        var form_data = new FormData();
    
        for (var key in formData) {
            form_data.append(key, formData[key]);
        }
        const response = await axios({
            method: "post",
            url: `${BASE_URL}/api-v1/${this.requestUrlParam}/create`,
            data: form_data,
            withCredentials: true
        }
        ).then((response) => response.data)
            .catch((error) => error);
        return response;
    
    
    }
    async changePasswordUserOrAgent(formData,user_id)  {

        var form_data = new FormData();
    
        for (var key in formData) {
            form_data.append(key, formData[key]);
        }
        const response = await axios({
            method: "post",
            url: `${BASE_URL}/api-v1/${this.requestUrlParam}/${user_id}/change-password`,
            data: form_data,
            withCredentials: true
        }
        ).then((response) => response.data)
            .catch((error) => error);
        return response;
    
    
    }

   async saveProduct  (formData,user_id=null)  {

    console.log(formData)
        var form_data = new FormData();
        var product_id = null;
        for (var key in formData) {
            if (key === "id") {
                product_id = formData[key];
            }
             else {
                form_data.append(key, formData[key]);
            }
        }
        if(user_id!== null){
            product_id = user_id;
        }
    
        const response = await axios({
            method: "post",
            url: `${BASE_URL}/api-v1/${this.requestUrlParam}/${product_id}/save`,
            data: form_data,
            withCredentials: true
        }
        ).then((response) => response.data)
            .catch((error) => error);
        return response;
    
    
    }

    async toggleSuspendProduct (product_id, is_suspending) {


        const response = await axios({
            method: "post",
            url: `${BASE_URL}/api-v1/${this.requestUrlParam}/${product_id}/toggle-suspend`,
            withCredentials: true
        }
        ).then((response) => response.data)
            .catch((error) => error);
        return response;
    
        //   const result = await  Swal.fire({
        //         title: 'Do you want to save the changes?',
        //         showDenyButton: true,
        //         showCancelButton: false,
        //         confirmButtonText: 'Si',
        //         denyButtonText: `No`,
        //       })
    
        //       if (result.isConfirmed) {
        //         const response = await axios({
        //             method: "post",
        //             url: `${BASE_URL}/api-v1/product/${product_id}/toggle-suspend`,
        //             withCredentials: true
        //         }
        //          ).then((response)=>response.data)
        //           .catch((error)=>error);  
        //         return response;
    
        //     } else if (result.isDenied) {
        //         return null;
        //       }
    }

    async toggleCanCreateProduct (product_id) {
        const response = await axios({
            method: "post",
            url: `${BASE_URL}/api-v1/${this.requestUrlParam}/${product_id}/toggle-can-create`,
            withCredentials: true
        }
        ).then((response) => response.data)
            .catch((error) => error);
        return response;
    }


    async deleteProduct  (product_id) {
        //   const result = await  Swal.fire({
        //         title: 'Do you want to save the changes?',
        //         showDenyButton: true,
        //         showCancelButton: false,
        //         confirmButtonText: 'Si',
        //         denyButtonText: `No`,
        //       })
    
        //       if (result.isConfirmed) {
        //         const response = await axios({
        //             method: "post",
        //             url: `${BASE_URL}/api-v1/product/${product_id}/toggle-suspend`,
        //             withCredentials: true
        //         }
        //          ).then((response)=>response.data)
        //           .catch((error)=>error);  
        //         return response;
    
        //     } else if (result.isDenied) {
        //         return null;
        //     }
    }

    async deleteProduct (product_id) {

        const result = await Swal.fire({
            title: 'Sei sicuro di voler eliminare?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Si',
            denyButtonText: `No`
        })
    
        if (result.isConfirmed) {
    
            const response = await axios({
                method: "post",
                url: `${BASE_URL}/api-v1/${this.requestUrlParam}/${product_id}/delete`,
            }
            ).then((response) => response.data)
                .catch((error) => error);
            return response;
        } else if (result.isDenied) {
            return null;
        }
        return null;
    
    
    }


    async toggleEnableProductForUserOrAgency  (product_id, user_or_agency_id, user_type, enable, itemType = 'product') {
        

        var confirmed = true;
        if(!enable){
            const result = await Swal.fire({
                title: 'Sei sicuro?',
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: 'Si',
                denyButtonText: `No`
            });
            confirmed = result.isConfirmed;
            
        }
    
        if (confirmed) {
            const is_agency = user_type === 'agency';
            // Use different endpoint based on itemType (product or campaign)
            const endpoint = itemType === 'campaign' ? 'enable-campaign' : 'enable-product';
            const response = await axios({
                method: "post",
                url: `${BASE_URL}/api-v1/${this.requestUrlParam}/${product_id}/${endpoint}/${user_or_agency_id}`,
                data : JSON.stringify({"is_agency" : is_agency, "enable" : enable}),
            }
            ).then((response) => response.data)
                .catch((error) => error);
            return response;
        } 
        return null;
    
    }

   async getProductInfo  (product_id) {

        console.log("Fetching product info...");
        console.log("Getting product info for ID:", product_id);
        console.log("Using request URL param:", this.requestUrlParam);

        const response = await axios({
            method: "get",
            url: `${BASE_URL}/api-v1/${this.requestUrlParam}/${product_id}/view`,
            withCredentials: true
        }
        ).then((response) => response.data)
            .catch((error) => error);
        return response;
    
    }

    async bulkAssignUser(contactIds, assignedUserId, assignedAgencyId) {
        try {
            var form_data = new FormData();
            
            // Append contact_ids as JSON string or individual items
            form_data.append('contact_ids', JSON.stringify(contactIds));
            
            if (assignedUserId !== null && assignedUserId !== undefined) {
                form_data.append('assigned_user_id', assignedUserId);
            }
            if (assignedAgencyId !== null && assignedAgencyId !== undefined) {
                form_data.append('assigned_agency_id', assignedAgencyId);
            }
            
            const response = await axios({
                method: "post",
                url: `${BASE_URL}/api-v1/${this.requestUrlParam}/bulk-assign-user`,
                data: form_data,
                withCredentials: true
            });
            
            return response.data;
        } catch (error) {
            console.error("Error in bulkAssignUser:", error);
            
            // Return error details without propagating to interceptor
            if (error.response) {
                return {
                    error: error.response.data?.error || error.response.data?.detail || 'Errore del server',
                    status: error.response.status
                };
            } else if (error.request) {
                return {
                    error: 'Nessuna risposta dal server',
                    status: 0
                };
            } else {
                return {
                    error: error.message || 'Errore sconosciuto',
                    status: 0
                };
            }
        }
    }

    async assignUser(contactId, assignedUserId, assignedAgencyId) {
        try {

            console.log(1)
            var form_data = new FormData();
            console.log(2)
            
            if (assignedUserId !== null && assignedUserId !== undefined) {
                form_data.append('assigned_user_id', assignedUserId);
            }
            console.log(3)

            if (assignedAgencyId !== null && assignedAgencyId !== undefined) {
                form_data.append('assigned_agency_id', assignedAgencyId);
            }
            console.log(4)
            
            const response = await axios({
                method: "post",
                url: `${BASE_URL}/api-v1/${this.requestUrlParam}/${contactId}/assign-user`,
                data: form_data,
                withCredentials: true
            });
            
            return response.data;
        } catch (error) {
            console.error("Error in assignUser:", error);
            
            // Return error details without propagating to interceptor
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                return {
                    error: error.response.data?.error || error.response.data?.detail || 'Errore del server',
                    status: error.response.status
                };
            } else if (error.request) {
                // The request was made but no response was received
                return {
                    error: 'Nessuna risposta dal server',
                    status: 0
                };
            } else {
                // Something happened in setting up the request that triggered an Error
                return {
                    error: error.message || 'Errore sconosciuto',
                    status: 0
                };
            }
        }
    }
}

export default ServicesRequest;
